import React, { FC } from 'react';

export enum DataTestId {
    AVATAR = 'avatar',
    CLICK_OUT = 'click-out',
    DRAWER_CLOSE_BUTTON = 'drawer-close-button',
    DIALOG_CLOSE_BUTTON = 'dialog-close-button',
    SIDEBAR_APP_QR = 'sidebar-app-qr',
    SIDEBAR_APP_LINK = 'sidebar-app-link',
    SIDEBAR_APP_DOWNLOAD = 'sidebar-app-download',
    SIDEBAR_CREATE_COLLECTION = 'sidebar-create-collection',
    SIDEBAR_LINK_ABOUT = 'sidebar-link-about',
    SIDEBAR_LINK_FOR_BUSINESS = 'sidebar-link-for-business',
    SIDEBAR_LINK_FOR_USERS = 'sidebar-link-for-users',
    SIDEBAR_LINK_TERMS = 'sidebar-link-terms',
    SIDEBAR_LINK_CONFIDENTIAL = 'sidebar-link-confidential',
    SIDEBAR_LINK_RECOMMENDATIONS = 'sidebar-link-recommendations',
    APPS_QR_DIALOG = 'apps-qr-dialog',
    CREATE_COLLECTION_ADD_POST = 'create-collection-add-post',
    CREATE_COLLECTION_NEXT = 'create-collection-next',
    CREATE_COLLECTION_SUBMIT = 'create-collection-submit',
    COLLECTION_ADD_TO_FEED = 'collection-add-to-feed',
    COLLECTION_PROMOTE_FEED_SAVE = 'collection-promote-feed-save',
    COLLECTION_CREATE_FROM_FOOTER = 'collection-create-from-footer',
    BUSINESS_LOGIN = 'business-login',
    USER_LOGIN = 'user-login',
    SEARCH = 'search',
    MUTE = 'mute',
    POST_CARD_KEBAB = 'post-card-kebab',
    POST_CARD_KEBAB_BUTTON = 'post-card-kebab-button',
    POST_COLLECTION_CARD_KEBAB = 'post-collection-card-kebab',
    COLLECTION_KEBAB = 'collection-kebab',
    COLLECTION_MENU = 'collection-menu',
    COLLECTION_STATUS_DRAWER_TITLE = 'collection-status-drawer-title',
    COLLECTION_STATUS_DRAWER_DESCRIPTION_MODERATION = 'collection-status-drawer-description-moderation',
    PROFILE_KEBAB = 'profile-kebab',
    SUBSCRIBE_TEXT = 'subscribe-text',
    UNSUBSCRIBE_TEXT = 'unsubscribe-text',
    REPORT_TEXT = 'report-text',
    POST_PUBLISH_TEXT = 'post-publish-text',
    GO_TO_PROFILE_TEXT = 'go-to-profile-text',
    DISLIKE_TEXT = 'dislike-text',
    COLLECTION_STATUS_TEXT = 'collection-status-text',
    REPORT_REASON_OTHER = 'report-reason-other',
    SEND_REPORT_BUTTON = 'send-report-button',
    CONFIRM_BUTTON = 'confirm-button',
    SUBSCRIBE_BUTTON = 'subscribe-button',
    UNSUBSCRIBE_BUTTON = 'unsubscribe-button',
    SHARE = 'share',
    SHARE_TEXT = 'share-text',
    SHARE_BUTTON = 'share-button',
    PROFILE = 'profile',
    PROFILE_MENU = 'profile-menu',
    FEED_MANAGEMENT = 'feed-management',
    BOOKMARK = 'bookmark',
    COLLECTION_BOOKMARK = 'collection_bookmark',
    STICKY_FOOTER_ACTIONS_LIKE = 'sticky_footer_actions_like',
    STICKY_FOOTER_ACTIONS_BOOKMARK = 'sticky_footer_actions_bookmark',
    FILLED = 'filled',
    EMPTY = 'empty',
    LIKE = 'like',
    DISLIKE = 'dislike',
    SUBSCRIBE_ICON = 'subscribe-icon',
    ANIMATE_FOOTER_DESCRIPTION = 'animate_footer_description',
    SLIDER_LEFT = 'slider-left',
    SLIDER_RIGHT = 'slider-right',
    EDIT_TEXT = 'edit-text',
    DELETE_TEXT = 'delete-text',
    COLLECTION_NAME = 'collection-name',
    COLLECTION_NAVIGATE_BACK = 'collection-navigate-back',
    COLLECTION_CARD_FROM_PROFILE = 'collection-card-from-profile',
    DELETE_FROM_COLLECTION = 'delete-from-collection',
    ONLY_IN_COLLECTION = 'only-in-collection',
    EVERYWHERE = 'everywhere',
    SAVE_TO_COLLECTION_DRAWER = 'save-to-collection-drawer',
    ADD_NEW_COLLECTION = 'add-new-collection',
    ADD_TO_FAVORITE = 'add-to-favorite',
    SAVE_TO_NEW_COLLECTION_BUTTON = 'save-to-new-collection-button',
    COLLECTION_NAME_INPUT = 'collection-name-input',
    EDIT_COLLECTION_DRAWER = 'edit-collection-drawer',
    BUSINESS_PROFILES = 'business-profiles',
    SEARCH_INPUT = 'search-input',
    SUBSCRIBED = 'subscribed',
    UNSUBSCRIBED = 'unsubscribed',
    BUSINESS_SEARCH_ROW = 'business-search-row',
    SAVE_POST_BUTTON = 'save-post-button',
    ADD_POST_BUTTON = 'add-post-button',
    SET_POST_FORM_FIELD = 'set-post-form-field',
    ADD_LINK_TO_PRODUCT_BLOCK = 'add-link-to-product-block',
    MODERATION_STATUS_CLOCK = 'moderation-status-clock',
    POST_TEXT = 'post-text',
    POST_TEXT_FOOTER = 'post-text-footer',
    POST_CARD_COMPACT = 'post-card-compact',
    POST_CARD_GRID = 'post-card-grid',
    POST_CARD_GRID_MEDIA_COVER = 'post-card-grid-media-cover',
    CROSS_BUTTON = 'cross-button',
    DISCOVERY_BUTTON = 'discovery-button',
    SUPPORT = 'support',
    USER_AGREEMENT = 'user-agreement',
    APPLY_BETA_TEST = 'apply-beta-test',
    SAVE_COLLECTION = 'save-collection',
    REMOVE_SAVED_COLLECTION = 'remove-saved-collection',
    SAVED = 'saved',
    CREATED = 'created',
    EMPTY_COLLECTION_TEXT = 'empty-collection-text',
    SECRET_COLLECTION_RADIO = 'secret-collection-radio',
    PUBLIC_COLLECTION_RADIO = 'public-collection-radio',
    EDIT_COLLECTION_SUBMIT_BUTTON = 'edit-collection-submit-button',
    CREATE_COLLECTION_DIALOG = 'create-collection-dialog',
    CONTENT_PROMOTION_CHOOISING_POSTS_DIALOG = 'content-promotion-chooising-posts-dialog',
    CONTENT_PROMOTION_CHOOISING_GOALS_DIALOG = 'content-promotion-chooising-goals-dialog',
    CONTENT_PROMOTION_DATE = 'content-promotion-date',
    CONTENT_PROMOTION_DATE_NOW = 'content-promotion-date-now',
    CONTENT_PROMOTION_DATE_INPUT = 'content-promotion-date-input',
    ABOUT_CONTENT_PROMOTION_ICON_TEST_ID = 'about-content-promotion-icon',
    ABOUT_CONTENT_PROMOTION_MODAL_TEST_ID = 'about-content-promotion-modal',
    DESCRIPTION_STATUS = 'description-status',
    FEED_MANAGEMENT_FILTERS_DRAWER = 'feed-management-filters-drawer',
    FEED_MANAGEMENT_ROW = 'feed-management-row',
    FEED_MANAGEMENT_ROW_KEBAB = 'feed-management-row-kebab',
    FEED_MANAGEMENT_ROW_STATUS = 'feed-management-row-status',
    FEED_MANAGEMENT_ROW_PROMOTION = 'feed-management-row-promotion',
    FEED_MANAGEMENT_FILTER_SOURCE = 'feed-management-filter-source',
    FEED_MANAGEMENT_FILTER_STATUS = 'feed-management-filter-status',
    FEED_MANAGEMENT_FILTER_PERIOD = 'feed-management-filter-period',
    FEED_MANAGEMENT_COLUMNS_MENU = 'feed-management-columns-menu',
    FEED_MANAGEMENT_PROMOTION_HELP = 'feed-management-promotion-help',
    FEED_MANAGEMENT_PROMOTION_DRAWER = 'feed-management-promotion-drawer',
    STATISTIC_SECTION_HELP = 'statistic-section-help',
    CONTENT_PROMOTION_START = 'content-promotion-start',
    FEED_MANAGEMENT_TAB_CONTENT = 'feed-management-tab-content',
    FEED_MANAGEMENT_TAB_STATISTIC = 'feed-management-tab-statistic',
    CPA_REWARD_CONTENT_TEXT = 'cpa-reward-content-text',
    CPA_REWARD_CONTENT_BUTTON = 'cpa-reward-content-button',
    POST_CONTEXT_MENU = 'post-context-menu',
    BUSINESS_STATISTIC_INFO_DIALOG = 'business-statistic-info-dialog',
    CHECKOUT_BADGE = 'checkout-badge',
    CHECKOUT_BADGE_TOOLTIP = 'checkout-badge-tooltip',
    PRODUCT_SNIPPET_CHECKOUT_BUTTON = 'product-snippet-checkout-button',
    FILE_LOADING_NOTIFICATION = 'file-loading-notification',
    BUSINESS_TYPE_ACCOUNT_DRAWER = 'business-type-account-drawer',
    STORYBOOK_CARD_ACTIONS = 'storybook-card-actions',
    STORYBOOK_POST_TEXT_CONTROLS = 'storybook-post-text-controls',
    STORYBOOK_POST_CONTROLS = 'storybook-post-controls',
    STORYBOOK_POST_DETAILS_CARD = 'storybook-post-details-card',
    INPUT_SUGGEST = 'input-suggest',
    INPUT_SUGGEST_ITEM = 'input-suggest-item',
    MESSAGE_TOAST = 'message-toast',
    SEARCH_NOT_FOUND = 'search-not-found',
    SEARCH_POSTS_SCROLL_CONTAINER = 'search-posts-scroll-container',
    SEARCH_PROFILES_SCROLL_CONTAINER = 'search-profiles-scroll-container',
    POST_AI_LABEL = 'post_ai_label',
    USER_SUBSCRIPTIONS_SEARCH_INPUT = 'user_subscriptions_search_input',
    USER_SUBSCRIPTIONS_SEARCH_INPUT_CLEAR = 'user_subscriptions_search_input_clear',
    BUSINESS_DETAILS_TAB_POSTS = 'business_details_tab_posts',
    BUSINESS_DETAILS_TAB_COLLECTIONS = 'business_details_tab_collections',
    BUSINESS_DETAILS_TAB_MODERATION = 'business_details_tab_moderation',
    BUSINESS_DETAILS_TAB_SAVED_COLLECTIONS = 'business_details_tab_saved_collections',
    BUSINESS_DETAILS_TAB_CREATED = 'business_details_tab_saved_created',
    BUSINESS_DETAILS_TAB_SAVED = 'business_details_tab_saved_saved',
    COLLECTION_LIST_ITEM = 'collection_list_item',
    POST_CAROUSEL = 'post_carousel',
}

interface DataTestIdWrapperProps {
    children: React.ReactNode;
    dataTestId: DataTestId;
}

export const DataTestIdWrapper: FC<DataTestIdWrapperProps> = ({ children, dataTestId }) => (
    // TODO: Сделать привязку к dev окрожению, когда появится беты
    <div data-test-id={dataTestId}>{children}</div>
);
